module.exports = "/img/13.19c1e6.webp";